export const SEARCH_FORM_CHANGED = 'SEARCH_FORM_CHANGED';
export const SEARCH_COUNT_RETRIEVED = 'SEARCH_COUNT_RETRIEVED';
export const QUICKSEARCH_SUBMITTED = 'QUICKSEARCH_SUBMITTED';

export const SEARCH_MERGE = `SEARCH_MERGE`;
export const SEARCH_UPDATE = `SEARCH_UPDATE`;

